import React from 'react';
import * as Sentry from '@sentry/react';
import { Button, Typography, Box, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

// Custom fallback component that displays when an error occurs
const FallbackComponent = ({ error, resetError }) => {
  return (
    <Box 
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Paper 
        elevation={3}
        sx={{
          padding: 4,
          maxWidth: '500px',
          textAlign: 'center',
        }}
      >
        <ErrorOutlineIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
        <Typography variant="h5" component="h2" gutterBottom>
          Something went wrong
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          We've been notified about this issue and we're working to fix it.
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph sx={{ mb: 3 }}>
          Error details: {error.toString()}
        </Typography>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={resetError}
        >
          Try Again
        </Button>
      </Paper>
    </Box>
  );
};

// Export the Sentry error boundary with our custom fallback
export default Sentry.withErrorBoundary(({ children }) => {
  return children;
}, {
  fallback: FallbackComponent,
  showDialog: true,
});
